var path = 'src/app/crud/save-button.html';
var html = "<button ng-disabled=\"!valid || !enabled\" type=button class=\"btn btn-success\" ng-click=click()> <i class=\"fa fa-floppy-o\" ng-show=!submitting></i> <i class=\"fa fa-spinner fa-spin\" ng-show=submitting></i> {{text || 'Save'}} </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/crud/save-button.html
 ** module id = 98
 ** module chunks = 0
 **/